export const languageElements = {
        "items": {
            "message-expires-shortly": {
                "hu": "A belépési engedély rövidesen lejár!",
                "de": "User Token läuft bald ab!",
                "en": "Access authorization expires shortly!"
            },

            "btn-extend": {
                "hu": " Meghosszabbítás",
                "de": " Gültigkeit verlängern.",
                "en": " Extend authorization"
            }
        }
    }
